// import React, { useEffect, useState, useCallback } from 'react';
// import { useNavigate } from 'react-router-dom';
// import api from '../utils/api';
// import DotGrid from '../components/DotGrid';
// import './SummerOfTech.css';

// const BACKEND = process.env.REACT_APP_BACKEND_URL;

// export default function SummerOfTech({ authToken }) {
//   const [domains, setDomains] = useState([]);
//   const [memberships, setMemberships] = useState([]);
//   const [isManager, setIsManager] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [roleModal, setRoleModal] = useState(null); // { domain, options: [{ role, action, label }] }
//   const [darkMode, setDarkMode] = useState(false);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const savedTheme = localStorage.getItem('theme');
//     setDarkMode(savedTheme === 'dark');
    
//     const observer = new MutationObserver(() => {
//       const isDark = document.documentElement.classList.contains('dark');
//       setDarkMode(isDark);
//     });
//     observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    
//     return () => observer.disconnect();
//   }, []);

//   const fetchDomains = useCallback(async () => {
//     try {
//       const res = await api.get(`${BACKEND}/domains/`);
//       setDomains(res.data);
//     } catch (e) {
//       console.error('Failed to fetch domains', e);
//     }
//   }, []);

//   const fetchMemberships = useCallback(async () => {
//     if (!authToken) return;
//     try {
//       const res = await api.get(`${BACKEND}/accounts/my-memberships/`);
//       setMemberships(res.data.memberships || []);
      
//       // Update local state and sync to localStorage for routing guards
//       const managerFlag = res.data.is_manager || false;
//       setIsManager(managerFlag);
//       localStorage.setItem('is_manager', managerFlag ? 'true' : 'false');
//     } catch (e) {
//       console.error('Failed to fetch memberships', e);
//     }
//   }, [authToken]);

//   useEffect(() => {
//     Promise.all([fetchDomains(), fetchMemberships()]).finally(() => setLoading(false));
//   }, [fetchDomains, fetchMemberships]);

//   const getMyRoles = (domainSlug) =>
//     memberships
//       .filter((m) => m.domain === domainSlug && m.is_approved)
//       .map((m) => m.role);

//   const handleDomainClick = (domain) => {
//     if (!authToken) {
//       navigate('/login');
//       return;
//     }
    
//     const roles = getMyRoles(domain.slug);
    
//     // Always show role selection modal for logged-in users
//     // If they have roles, show "Open Portal" options
//     // If they don't have roles, show "Apply" options
//     const availableOptions = [];
    
//     if (roles.includes('mentor')) {
//       availableOptions.push({ role: 'mentor', action: 'open', label: 'Open Mentor Portal' });
//     } else if (domain.mentor_reg_open) {
//       availableOptions.push({ role: 'mentor', action: 'apply', label: 'Apply as Mentor' });
//     }
    
//     if (roles.includes('mentee')) {
//       availableOptions.push({ role: 'mentee', action: 'open', label: 'Open Mentee Portal' });
//     } else if (domain.mentee_reg_open) {
//       availableOptions.push({ role: 'mentee', action: 'apply', label: 'Register as Mentee' });
//     }
    
//     if (availableOptions.length === 0) {
//       alert('Registration is currently closed for this domain.');
//       return;
//     }
    
//     setRoleModal({ domain, options: availableOptions });
//   };

//   const handleLogin = () => navigate('/login');

//   const handleModalAction = async (domain, role, action) => {
//     if (action === 'open') {
//       setRoleModal(null);
//       if (role === 'mentor') {
//         navigate(`/${domain.slug}/mentor/home`);
//       } else {
//         navigate(`/${domain.slug}/current_projects`);
//       }
//     } else if (action === 'apply') {
//       try {
//         await api.post(`${BACKEND}/domains/${domain.slug}/members/`, { role });
//         setRoleModal(null);
//         if (role === 'mentee') {
//           alert('Successfully registered as mentee! You can now browse projects.');
//           navigate(`/${domain.slug}/current_projects`);
//         } else {
//           alert('Successfully applied as mentor! Your application is pending approval.');
//           fetchMemberships();
//         }
//       } catch (err) {
//         alert(err.response?.data?.error || 'Failed to apply');
//       }
//     }
//   };

//   const roleBadgeClass = (role) => {
//     const map = { manager: 'badge-manager', mentor: 'badge-mentor', mentee: 'badge-mentee' };
//     return `sot-badge ${map[role] || 'badge-other'}`;
//   };

//   if (loading) {
//     return (
//       <div className="sot-loading">
//         <div className="sot-loader" />
//       </div>
//     );
//   }

//   return (
//     <div className="sot-root" style={{ paddingTop: '12px' }}>
//       {/* Hero */}
//       <section className="sot-hero">
//         <DotGrid
//           dotSize={5}
//           gap={15}
//           baseColor={darkMode ? '#000000' : '#d1d5db'}
//           activeColor={darkMode ? '#5227FF' : '#4f46e5'}
//           proximity={120}
//           shockRadius={250}
//           shockStrength={5}
//           resistance={750}
//           returnDuration={1.5}
//         />
//         <div className="sot-hero-content">
//           {/* <div className="sot-hero-badge">IIT Bombay · ITC</div> */}
//           <h1 className="sot-hero-title">
//             Summer of <span className="sot-hero-accent">Tech</span>
//           </h1>
//           <p className="sot-hero-sub">
//             Explore projects across Coding, Quants, Robotics and more. Find your domain. Build something extraordinary.
//           </p>
//           {!authToken ? (
//             <button className="sot-btn-primary" onClick={handleLogin}>
//               Login with ITC SSO
//               <span className="sot-btn-arrow">→</span>
//             </button>
//           ) : (
//             <div className="sot-hero-actions">
//               {isManager && (
//                 <button className="sot-btn-manager" onClick={() => navigate('/manager')}>
//                   Manager Dashboard
//                 </button>
//               )}
//               {memberships.length > 0 && (
//                 <p className="sot-hero-welcome">
//                   You're enrolled in {memberships.filter((m) => m.is_approved).length} domain{memberships.length !== 1 ? 's' : ''}
//                 </p>
//               )}
//             </div>
//           )}
//         </div>

//         {/* Floating orbs */}
//         {/* <div className="sot-orb sot-orb-1" aria-hidden="true" /> */}
//         {/* <div className="sot-orb sot-orb-2" aria-hidden="true" /> */}
//         {/* <div className="sot-orb sot-orb-3" aria-hidden="true" /> */}
//       </section>

//       {/* My Memberships strip (if logged in) */}
//       {authToken && memberships.filter((m) => m.is_approved).length > 0 && (
//         <section className="sot-my-section">
//           <div className="sot-my-inner">
//             <h2 className="sot-my-title">Your Memberships</h2>
//             <div className="sot-my-chips">
//               {memberships
//                 .filter((m) => m.is_approved)
//                 .map((m, i) => (
//                   <button
//                     key={i}
//                     className="sot-my-chip"
//                     onClick={() => m.domain && handleDomainClick({ slug: m.domain })}
//                   >
//                     <span className="sot-my-chip-domain">{m.domain_name || 'Platform'}</span>
//                     <span className={roleBadgeClass(m.role)}>{m.role}</span>
//                   </button>
//                 ))}
//             </div>
//           </div>
//         </section>
//       )}

//       {/* Domains Grid */}
//       <section className="sot-domains-section">
//         <div className="sot-domains-inner">
//           <div className="sot-section-header">
//             <h2 className="sot-section-title">Explore Domains</h2>
//             <p className="sot-section-sub">
//               Each domain runs independently with its own mentors, mentees, and projects.
//             </p>
//           </div>

//           {domains.length === 0 ? (
//             <div className="sot-empty">
//               <p>No domains published yet. Check back soon!</p>
//             </div>
//           ) : (
//             <div className="sot-grid">
//               {domains.map((domain) => {
//                 const myRoles = getMyRoles(domain.slug);
//                 return (
//                   <DomainCard
//                     key={domain.slug}
//                     domain={domain}
//                     myRoles={myRoles}
//                     authToken={authToken}
//                     onClick={() => handleDomainClick(domain)}
//                   />
//                 );
//               })}
//             </div>
//           )}
//         </div>
//       </section>

//       {/* Footer */}
//       <footer className="sot-footer">
//         <p>© {new Date().getFullYear()} ITC, IIT Bombay · Summer of Tech</p>
//       </footer>

//       {/* Role Selection Modal */}
//       {roleModal && (
//         <div className="sot-modal-overlay" onClick={() => setRoleModal(null)}>
//           <div className="sot-modal" onClick={(e) => e.stopPropagation()}>
//             <h3 className="sot-modal-title">{roleModal.domain.name}</h3>
//             <p className="sot-modal-desc">
//               Choose how you want to participate in this domain:
//             </p>
//             <div className="sot-modal-actions">
//               {roleModal.options.map((option, idx) => (
//                 <button
//                   key={idx}
//                   className={`sot-modal-btn ${
//                     option.role === 'mentor' ? 'sot-modal-btn-mentor' : 'sot-modal-btn-mentee'
//                   }`}
//                   onClick={() => handleModalAction(roleModal.domain, option.role, option.action)}
//                 >
//                   {option.role === 'mentor' ? '🎓' : '👤'} {option.label}
//                   {option.action === 'apply' && (
//                     <span style={{ fontSize: '0.75rem', display: 'block', marginTop: '4px', opacity: 0.8 }}>
//                       {option.role === 'mentor' ? 'Requires approval' : 'Browse & apply to projects'}
//                     </span>
//                   )}
//                 </button>
//               ))}
//             </div>
//             <button className="sot-modal-close" onClick={() => setRoleModal(null)}>
//               Cancel
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// function DomainCard({ domain, myRoles, authToken, onClick }) {
//   const [hovered, setHovered] = useState(false);

//   const slugColors = {
//     soc: { from: '#6366f1', to: '#8b5cf6' },
//     soq: { from: '#06b6d4', to: '#0ea5e9' },
//     sor: { from: '#f59e0b', to: '#ef4444' },
//   };
//   const colors = slugColors[domain.slug] || { from: '#10b981', to: '#059669' };

//   return (
//     <div
//       className={`sot-card ${hovered ? 'sot-card-hovered' : ''}`}
//       onMouseEnter={() => setHovered(true)}
//       onMouseLeave={() => setHovered(false)}
//       onClick={onClick}
//       role="button"
//       tabIndex={0}
//       onKeyDown={(e) => e.key === 'Enter' && onClick()}
//       aria-label={`Open ${domain.name}`}
//     >
//       {/* Cover */}
//       <div
//         className="sot-card-cover"
//         style={{
//           background: domain.cover_photo_url
//             ? `url(${domain.cover_photo_url}) center/cover`
//             : `linear-gradient(135deg, ${colors.from}, ${colors.to})`,
//         }}
//       >
//         <div className="sot-card-cover-overlay" />
//         <div className="sot-card-slug">{domain.slug.toUpperCase()}</div>

//         {/* My role badges in this domain */}
//         {myRoles.length > 0 && (
//           <div className="sot-card-role-badges">
//             {myRoles.map((role) => (
//               <span key={role} className={`sot-card-role-badge sot-card-role-${role}`}>
//                 {role}
//               </span>
//             ))}
//           </div>
//         )}
//       </div>

//       {/* Body */}
//       <div className="sot-card-body">
//         <h3 className="sot-card-name">{domain.name}</h3>
//         <p className="sot-card-desc">
//           {domain.description
//             ? domain.description.length > 120
//               ? domain.description.slice(0, 120) + '…'
//               : domain.description
//             : 'A new domain under Summer of Tech.'}
//         </p>

//         <div className="sot-card-footer">
//           <span className="sot-card-count">
//             {domain.member_count} member{domain.member_count !== 1 ? 's' : ''}
//           </span>
          
//           {/* Registration status badges */}
//           <div className="sot-card-reg-status">
//             {domain.mentee_reg_open && (
//               <span className="sot-reg-badge sot-reg-open">Mentee: Open</span>
//             )}
//             {domain.mentor_reg_open && (
//               <span className="sot-reg-badge sot-reg-open">Mentor: Open</span>
//             )}
//           </div>

//           {!authToken ? (
//             <span className="sot-card-cta">Login to explore →</span>
//           ) : (
//             <span className="sot-card-cta sot-card-cta-enrolled">Explore →</span>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import api from '../utils/api';
import './SummerOfTech.css';

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function SummerOfTech({ authToken }) {
  const [domains, setDomains] = useState([]);
  const [memberships, setMemberships] = useState([]);
  const [isManager, setIsManager] = useState(false);
  const [loading, setLoading] = useState(true);
  const [roleModal, setRoleModal] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  const fetchDomains = useCallback(async () => {
    try {
      const res = await api.get(`${BACKEND}/domains/`);
      setDomains(Array.isArray(res.data) ? res.data : []);
    } catch (e) {
      console.error('Failed to fetch domains', e);
      setDomains([]);
    }
  }, []);

  const fetchMemberships = useCallback(async () => {
    const token = authToken || localStorage.getItem('authToken');
    if (!token) return;
    try {
      const res = await api.get(`${BACKEND}/accounts/my-memberships/`);
      setMemberships(res.data.memberships || []);
      const managerFlag = res.data.is_manager || false;
      setIsManager(managerFlag);
      localStorage.setItem('is_manager', managerFlag ? 'true' : 'false');
      localStorage.setItem('memberships', JSON.stringify(res.data.memberships || []));
    } catch (e) {
      console.error('Failed to fetch memberships', e);
    }
  }, [authToken]);

  // Initial load
  useEffect(() => {
    Promise.all([fetchDomains(), fetchMemberships()]).finally(() => setLoading(false));
  }, [fetchDomains, fetchMemberships]);

  // Re-fetch when navigating back to home so new domains and memberships appear
  // without needing a manual page reload
  useEffect(() => {
    if (location.pathname === '/') {
      fetchDomains();
      fetchMemberships();
    }
  }, [location, fetchDomains, fetchMemberships]);

  const getMyRoles = (domainSlug) =>
    memberships
      .filter((m) => m.domain === domainSlug && m.is_approved)
      .map((m) => m.role);

  const handleDomainClick = (domain) => {
    if (!authToken) {
      navigate('/login');
      return;
    }
    
    const roles = getMyRoles(domain.slug);
    
    // Always show role selection modal for logged-in users
    // If they have roles, show "Open Portal" options
    // If they don't have roles, show "Apply" options
    const availableOptions = [];
    
    // Only show mentor portal option if mentor_portal_access is enabled
    if (roles.includes('mentor') && domain.mentor_portal_access !== false) {
      availableOptions.push({ role: 'mentor', action: 'open', label: 'Open Mentor Portal' });
    } else if (domain.mentor_reg_open) {
      availableOptions.push({ role: 'mentor', action: 'apply', label: 'Apply as Mentor' });
    }
    
    if (roles.includes('mentee')) {
      availableOptions.push({ role: 'mentee', action: 'open', label: 'Open Mentee Portal' });
    } else if (domain.mentee_reg_open) {
      availableOptions.push({ role: 'mentee', action: 'apply', label: 'Register as Mentee' });
    }
    
    if (availableOptions.length === 0) {
      alert('Registration is currently closed for this domain.');
      return;
    }
    
    setRoleModal({ domain, options: availableOptions });
  };

  const handleLogin = () => navigate('/login');

  const handleModalAction = async (domain, role, action) => {
    if (action === 'open') {
      setRoleModal(null);
      if (role === 'mentor') {
        navigate(`/${domain.slug}/mentor/home`);
      } else {
        navigate(`/${domain.slug}/current_projects`);
      }
    } else if (action === 'apply') {
      try {
        await api.post(`${BACKEND}/domains/${domain.slug}/members/`, { role });
        setRoleModal(null);
        
        // Refresh memberships immediately so the UI reflects the new role
        // without requiring a manual page reload.
        const res = await api.get(`${BACKEND}/accounts/my-memberships/`);
        const freshMemberships = res.data.memberships || [];
        const managerFlag = res.data.is_manager || false;
        setMemberships(freshMemberships);
        setIsManager(managerFlag);
        // Sync to localStorage so URLGuard allows the route
        localStorage.setItem('memberships', JSON.stringify(freshMemberships));
        localStorage.setItem('is_manager', managerFlag ? 'true' : 'false');

        if (role === 'mentee') {
          navigate(`/${domain.slug}/current_projects`);
        } else {
          alert('Successfully applied as mentor! Your application is pending approval.');
        }
      } catch (err) {
        alert(err.response?.data?.error || 'Failed to apply');
      }
    }
  };

  const roleBadgeClass = (role) => {
    const map = { manager: 'badge-manager', mentor: 'badge-mentor', mentee: 'badge-mentee' };
    return `sot-badge ${map[role] || 'badge-other'}`;
  };

  if (loading) {
    return (
      <div className="sot-loading">
        <div className="sot-loader" />
      </div>
    );
  }

  return (
    <>
      {/* Hero Section */}
      <section className="grid grid-cols-1 gap-4 lg:grid-cols-2 lg:gap-8 dark:bg-gray-800 min-h-[calc(100vh-72px)]">
         <div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0"
            y="0"
            enableBackground="new 0 0 500 500"
            viewBox="0 0 500 500"
            className="animate-fade-down m-auto lg:h-[calc(100vh-72px)]"
          >
            <ellipse
              cx="250"
              cy="358.491"
              fill="#F5F5F5"
              rx="222.503"
              ry="128.462"
            />
            <g fill="#E6E6E6">
              <ellipse cx="95.578" cy="369.756" rx="24.631" ry="14.22" />
              <path d="M285.257 293.531L123.382 386.99c-2.685 1.55-2.685 5.425 0 6.975l95.135 54.927a15.735 15.735 0 0015.733 0l161.875-93.459c2.685-1.55 2.685-5.425 0-6.975l-95.135-54.927a15.73 15.73 0 00-15.733 0z" />
              <path d="M236.654 294.441l-64.809 37.417c-5.703 3.293-5.703 11.525 0 14.817l32.635 18.842a14.2 14.2 0 0014.198 0l64.809-37.418c5.703-3.293 5.703-11.525 0-14.817l-32.635-18.842a14.202 14.202 0 00-14.198.001z" />
            </g>
            <g>
              <path
                fill="#BA68C8"
                d="M96.877 332.956s-15.221-14.863-6.558-39.761c4.855-13.955 20.94-24.201 30.102-25.165 0 0-4.97 5.727-7.158 12.071l-11.537 7.67 10.605-3.321-2.258 9.078s-9.864 5.965-11.325 7.266l10.633-2.779c-.002 0-.817 25.701-12.504 34.941z"
              />
              <path
                d="M96.877 332.956s-15.221-14.863-6.558-39.761c4.855-13.955 20.94-24.201 30.102-25.165 0 0-4.97 5.727-7.158 12.071l-11.537 7.67 10.605-3.321-2.258 9.078s-9.864 5.965-11.325 7.266l10.633-2.779c-.002 0-.817 25.701-12.504 34.941z"
                opacity="0.4"
              />
              <path
                fill="#FFF"
                d="M96.877 332.956s-7.881-31.104 3.779-49.242c0 0-13.669 16.005-3.779 49.242z"
              />
              <path
                fill="#37474F"
                d="M114.296 337.167l-18.623-.234v-.002l-.095.001-.095-.001v.002l-18.623.234s-.207 22.942 6.859 32.277c1.951 2.482 6.526 4.224 11.859 4.224 5.342 0 9.922-1.748 11.868-4.237 7.056-9.343 6.85-32.264 6.85-32.264z"
              />
              <ellipse
                cx="95.578"
                cy="337.167"
                fill="#455A64"
                rx="18.719"
                ry="10.049"
              />
              <path
                fill="#263238"
                d="M95.578 334.501c6.44 0 11.894 2.066 13.815 4.926.478-.712.746-1.47.746-2.261 0-3.969-6.519-7.187-14.561-7.187s-14.561 3.218-14.561 7.187c0 .791.268 1.549.746 2.261 1.921-2.86 7.375-4.926 13.815-4.926z"
              />
              <path
                fill="#E0E0E0"
                d="M95.578 334.501c-6.44 0-11.894 2.066-13.815 4.926 1.921 2.861 7.375 4.926 13.815 4.926 6.44 0 11.894-2.066 13.815-4.926-1.921-2.86-7.375-4.926-13.815-4.926z"
              />
              <g>
                <path
                  fill="#BA68C8"
                  d="M95.807 340.669s-7.214-.28-13.401-9.861c-2.552-3.951-3.782-6.027-3.782-6.027l10.051-.749-11.26-2.815-5.321-8.14 9.351-.694s-6.965-2.44-11.938-2.471c0 0-8.623-15.234-11.146-17.405 0 0 19.889.164 34.065 16.926s5.484 31.665 3.381 31.236z"
                />
                <path
                  fill="#FFF"
                  d="M95.807 340.669s4.512-27.175-24.281-43.522c0 0 29.883 14.354 24.281 43.522z"
                />
              </g>
              <g>
                <path
                  fill="#BA68C8"
                  d="M95.807 340.669s6.535.426 13.019-7.635c2.675-3.325 3.98-5.081 3.98-5.081l-8.998-1.622 10.424-1.479 5.567-6.843-8.372-1.507s6.514-1.545 11.003-1.106c0 0 9.215-12.932 11.695-14.653 0 0-17.96-1.724-32.328 12.063s-7.928 28.052-5.99 27.863z"
                />
                <path
                  d="M95.807 340.669s6.535.426 13.019-7.635c2.675-3.325 3.98-5.081 3.98-5.081l-8.998-1.622 10.424-1.479 5.567-6.843-8.372-1.507s6.514-1.545 11.003-1.106c0 0 9.215-12.932 11.695-14.653 0 0-17.96-1.724-32.328 12.063s-7.928 28.052-5.99 27.863z"
                  opacity="0.2"
                />
                <path
                  fill="#FFF"
                  d="M95.807 340.669s-1.512-24.943 26.005-36.98c0-.001-28.313 10.137-26.005 36.98z"
                />
              </g>
            </g>
            <g>
              <path
                fill="#FAFAFA"
                d="M128.906 119.397L128.906 169.077 85.882 193.917 85.882 144.237 128.906 119.397z"
              />
              <path
                fill="#E0E0E0"
                d="M124.248 122.086v44.301l-38.366 22.151v-44.301l38.366-22.151m2.329-4.034l-43.024 24.84v49.68l2.329 1.345 43.024-24.84v-49.68l-2.329-1.345z"
              />
              <path
                fill="#EBEBEB"
                d="M126.577 123.431v44.301l-38.366 22.151v-44.301l38.366-22.151m2.329-4.034l-43.024 24.84v49.68l43.024-24.84v-49.68z"
              />
              <g fill="#E0E0E0">
                <path d="M122.592 157.712L90.044 176.504 99.66 151.485 106.318 159.393 113.126 149.698z" />
                <path d="M111.301 142.105c0 1.893-1.329 4.196-2.969 5.142-1.64.947-2.969.179-2.969-1.714s1.329-4.196 2.969-5.142c1.64-.947 2.969-.18 2.969 1.714z" />
              </g>
              <g>
                <path
                  fill="#FAFAFA"
                  d="M143.261 57.545L143.261 97.122 108.986 116.911 108.986 77.334 143.261 57.545z"
                />
                <path
                  fill="#E0E0E0"
                  d="M139.55 59.687V94.98l-30.564 17.646V77.334l30.564-17.647m1.855-3.213L107.13 76.262v39.577l1.855 1.071 34.275-19.789V57.545l-1.855-1.071z"
                />
                <path
                  fill="#EBEBEB"
                  d="M141.405 60.758v35.293l-30.564 17.646V78.405l30.564-17.647m1.856-3.213l-34.275 19.789v39.577l34.275-19.789V57.545z"
                />
                <g fill="#E0E0E0">
                  <path d="M138.23 88.068L112.301 103.038 119.962 83.107 125.266 89.408 130.69 81.684z" />
                  <path d="M129.236 75.635c0 1.508-1.059 3.342-2.365 4.097-1.306.754-2.365.143-2.365-1.366s1.059-3.342 2.365-4.097c1.306-.754 2.365-.143 2.365 1.366z" />
                </g>
              </g>
            </g>
            <g>
              <path
                fill="#263238"
                d="M216.153 286.328l13.912 84.889a2.648 2.648 0 005.245-.721l-9.76-87.576-9.397 3.408zM264.173 257.777l13.912 84.889a2.648 2.648 0 005.245-.721l-9.76-87.576-9.397 3.408zM194.797 266.476l-13.728 73.154a2.217 2.217 0 01-2.193 1.819 2.238 2.238 0 01-2.206-2.555l10.141-67.8 7.986-4.618z"
              />
              <path
                fill="#263238"
                d="M243.36 239.188l-13.65 72.702a2.217 2.217 0 01-2.193 1.819 2.237 2.237 0 01-2.206-2.554l10.063-67.361 7.986-4.606z"
              />
              <path
                fill="#BA68C8"
                d="M239.4 233.654c-6.406-2.856-10.796-8.895-11.49-15.875-2.214-22.274-10.058-68.176-36.643-52.896-32.813 18.86-21.065 73.627-16.294 91.189a23.665 23.665 0 006.03 10.489c5.928 5.972 18.201 16.255 39.073 25.01a12.234 12.234 0 008.083.482c10.37-2.954 37.462-12.026 50.969-29.298a4.72 4.72 0 00-.779-6.603c-5.472-4.35-17.834-13.085-38.949-22.498z"
              />
              <path
                d="M239.4 233.654c-6.406-2.856-10.796-8.895-11.49-15.875-2.214-22.274-10.058-68.176-36.643-52.896-32.813 18.86-21.065 73.627-16.294 91.189a23.665 23.665 0 006.03 10.489c5.928 5.972 18.201 16.255 39.073 25.01a12.234 12.234 0 008.083.482c10.37-2.954 37.462-12.026 50.969-29.298a4.72 4.72 0 00-.779-6.603c-5.472-4.35-17.834-13.085-38.949-22.498z"
                opacity="0.5"
              />
              <path
                fill="#BA68C8"
                d="M280.105 259.61a4.687 4.687 0 01-.977 3.145 48.591 48.591 0 01-2.282 2.691l-.001.001c-.434.479-.879.95-1.332 1.415l-.027.028c-.45.46-.908.913-1.375 1.359l-.041.039c-.467.446-.943.885-1.426 1.317l-.036.032c-.487.436-.982.864-1.484 1.287l-.019.016c-7.66 6.433-16.956 11.327-25.268 14.86l-.032.014c-.518.22-1.03.434-1.539.643l-.16.066a156.393 156.393 0 01-4.52 1.767l-.357.132c-.383.142-.762.28-1.136.415l-.412.148c-.354.127-.705.251-1.05.372l-.435.151c-.328.114-.653.226-.972.334l-.465.156c-.298.1-.594.199-.883.294l-.501.163c-.266.086-.531.173-.788.255l-.534.169-.685.215-.576.177-.576.176-.704.21-.358.107c-.346.102-.68.198-.996.288-2.67.761-5.523.592-8.083-.482-20.872-8.755-33.145-19.038-39.073-25.01a23.665 23.665 0 01-6.03-10.489c-4.771-17.562-16.519-72.329 16.294-91.189a29.863 29.863 0 011.715-.906c.123-.06.246-.121.368-.179a24.351 24.351 0 011.641-.709c.053-.02.105-.037.157-.056a20.612 20.612 0 011.524-.508c.077-.022.155-.047.231-.068.539-.15 1.069-.272 1.589-.367l.133-.022a15.023 15.023 0 013.145-.221l.059.003c1.033.044 2.027.2 2.982.462-5.242-2.316-11.641-2.211-17.986 1.436-32.813 18.86-21.064 73.627-16.294 91.189l.807 3.017a28.542 28.542 0 0010.241 15.305l8.514 6.508v-.004c6.894 5.302 16.674 11.486 29.948 17.057a12.272 12.272 0 008.108.497c10.364-2.952 37.466-12.024 50.977-29.3.602-.77.912-1.667.971-2.572h.021v-5.849l-.012.015z"
              />
              <path
                d="M280.105 259.61a4.687 4.687 0 01-.977 3.145 48.591 48.591 0 01-2.282 2.691l-.001.001c-.434.479-.879.95-1.332 1.415l-.027.028c-.45.46-.908.913-1.375 1.359l-.041.039c-.467.446-.943.885-1.426 1.317l-.036.032c-.487.436-.982.864-1.484 1.287l-.019.016c-7.66 6.433-16.956 11.327-25.268 14.86l-.032.014c-.518.22-1.03.434-1.539.643l-.16.066a156.393 156.393 0 01-4.52 1.767l-.357.132c-.383.142-.762.28-1.136.415l-.412.148c-.354.127-.705.251-1.05.372l-.435.151c-.328.114-.653.226-.972.334l-.465.156c-.298.1-.594.199-.883.294l-.501.163c-.266.086-.531.173-.788.255l-.534.169-.685.215-.576.177-.576.176-.704.21-.358.107c-.346.102-.68.198-.996.288-2.67.761-5.523.592-8.083-.482-20.872-8.755-33.145-19.038-39.073-25.01a23.665 23.665 0 01-6.03-10.489c-4.771-17.562-16.519-72.329 16.294-91.189a29.863 29.863 0 011.715-.906c.123-.06.246-.121.368-.179a24.351 24.351 0 011.641-.709c.053-.02.105-.037.157-.056a20.612 20.612 0 011.524-.508c.077-.022.155-.047.231-.068.539-.15 1.069-.272 1.589-.367l.133-.022a15.023 15.023 0 013.145-.221l.059.003c1.033.044 2.027.2 2.982.462-5.242-2.316-11.641-2.211-17.986 1.436-32.813 18.86-21.064 73.627-16.294 91.189l.807 3.017a28.542 28.542 0 0010.241 15.305l8.514 6.508v-.004c6.894 5.302 16.674 11.486 29.948 17.057a12.272 12.272 0 008.108.497c10.364-2.952 37.466-12.024 50.977-29.3.602-.77.912-1.667.971-2.572h.021v-5.849l-.012.015z"
                opacity="0.6"
              />
              <path
                fill="#BA68C8"
                d="M298.213 322.277c-2.245-14.283-5.111-37.125-6.755-50.631a28.122 28.122 0 00-.447-2.632c-1.647-7.539-6.585-13.949-13.216-17.896l-33.657-20.037-22.851-12.018s-6.082 17.621.984 28.394c5.881 8.966 31.84 20.086 39.554 23.831 7.714 3.744 7.881 4.765 7.72 9.772s-.166 11.386 9.317 31.371c2.725 5.742 4.624 10.038 5.949 13.329 3.304.287 8.209-.121 13.402-3.483z"
              />
              <path
                d="M298.213 322.277c-2.245-14.283-5.111-37.125-6.755-50.631a28.466 28.466 0 00-.76-3.923c-1.873-6.994-6.625-12.868-12.846-16.572l-33.713-20.071-22.851-12.018s-6.082 17.621.984 28.394c5.881 8.966 31.84 20.086 39.554 23.831 7.714 3.744 7.881 4.765 7.72 9.772s-.166 11.386 9.317 31.371c2.725 5.742 4.624 10.038 5.949 13.329 3.303.288 8.208-.12 13.401-3.482z"
                opacity="0.7"
              />
              <path
                fill="#FFA8A7"
                d="M287.802 337.406a3.374 3.374 0 00.407 1.704c.628 1.154 2.063 3.318 5.063 6.025 4.534 4.089 19.565 20.093 24.85 10.158 0 0-15.528-14.873-17.586-20.99-.585-1.738-1.402-6.166-2.323-12.025-5.193 3.362-10.098 3.77-13.401 3.483 2.912 7.231 3.041 9.589 2.99 11.645z"
              />
              <path
                fill="#455A64"
                d="M303.961 336.433l-.431-1.29a1.945 1.945 0 00-2.418-1.243l-6.292 1.94c-.811.25-1.364 1-1.364 1.849v.629c0 .621-.503 1.124-1.124 1.124a5.743 5.743 0 01-3.651-1.311l-.879-.725v-2.199a3.864 3.864 0 00-1.754 3.439c.078 1.492.151 3.314.096 4.038-.101 1.314-1.337 6.818.135 8.445 1.473 1.627 4.767 1.82 8.847 1.38 4.08-.44 8.545 3.575 12.326 5.061s19.439 4.693 19.4-5.318c-.01-2.549-2.532-3.589-5.008-4.494-2.475-.905-11.413-4.052-13.704-5.942a21.266 21.266 0 01-2.551-2.517 8.521 8.521 0 01-1.628-2.866z"
              />
              <path
                fill="#263238"
                d="M307.452 357.569c-3.781-1.486-8.246-5.501-12.326-5.061-4.08.44-7.375.247-8.847-1.38-.443-.49-.639-1.335-.695-2.308-.076 1.54.044 3.02.695 3.74 1.473 1.627 4.767 1.82 8.847 1.38 4.08-.44 8.545 3.575 12.326 5.061 3.781 1.486 19.44 4.693 19.4-5.318-.001-.155-.038-.288-.057-.433-.99 8.786-15.694 5.753-19.343 4.319z"
              />
              <path
                fill="#BA68C8"
                d="M267.636 339.62c-2.245-14.283-5.111-37.124-6.755-50.631a28.453 28.453 0 00-9.819-18.24l-40.394-34.343-21.585-.372s-4.453 17.993 2.613 28.766c5.881 8.966 31.84 20.087 39.554 23.831 7.714 3.744 7.882 4.765 7.72 9.772-.161 5.007-.166 11.386 9.317 31.371 2.725 5.742 4.624 10.038 5.949 13.329 3.302.287 8.207-.121 13.4-3.483z"
              />
              <path
                d="M267.636 339.62c-2.245-14.283-5.111-37.124-6.755-50.631a28.453 28.453 0 00-9.819-18.24l-40.394-34.343-21.585-.372s-4.453 17.993 2.613 28.766c5.881 8.966 31.84 20.087 39.554 23.831 7.714 3.744 7.882 4.765 7.72 9.772-.161 5.007-.166 11.386 9.317 31.371 2.725 5.742 4.624 10.038 5.949 13.329 3.302.287 8.207-.121 13.4-3.483z"
                opacity="0.7"
              />
              <path
                fill="#FFA8A7"
                d="M257.214 353.464c-.015.597-.414 2.371.418 2.989 1.055.783 2.063 3.318 5.063 6.025 4.534 4.089 9.322-4.715 7.264-10.832-.585-1.738-1.402-6.166-2.323-12.025-5.193 3.362-10.098 3.77-13.401 3.483 2.912 7.231 3.03 8.304 2.979 10.36zM230.517 161.521c6.381-.996 12.588 2.729 14.613 8.861 1.216 3.684 2.307 8.18 2.73 13.213 1.165 13.851 1.489 20.777 1.489 20.777l13.914 6.311s-7.514.361-7.005 10.971l-17.33-4.369-8.411-55.764z"
              />
              <path
                fill="#BA68C8"
                d="M249.863 196c-2.05-15.006-2.864-22.849-4.624-26.575-2.758-5.839-8.341-8.9-14.722-7.905l5.239 41.201.675-.066a21.765 21.765 0 0012.474-5.514l.958-1.141z"
              />
              <path
                d="M249.863 196c-2.05-15.006-2.864-22.849-4.624-26.575-2.758-5.839-8.341-8.9-14.722-7.905l5.239 41.201.675-.066a21.765 21.765 0 0012.474-5.514l.958-1.141z"
                opacity="0.2"
              />
              <path
                fill="#F28F8F"
                d="M249.349 204.372s-2.654.777-4.11 2.524c0 0 1.678-3.19 4.025-4.175l.085 1.651z"
              />
              <path
                fill="#BA68C8"
                d="M197.099 173.666l15.563-7.537 12.822-4.425s10.272-3.277 12.901 10.413c2.161 11.253 2.444 54.008 2.444 54.008l-.229 4.679s-5.932 16.615-27.123 17.99c-21.191 1.375-25.315-7.56-25.315-7.56s-2.146-56.569 8.937-67.568z"
              />
              <path
                fill="#263238"
                d="M246.129 127.96s4.811 12.328-1.833 17.756c-6.644 5.428-4.341-16.382-4.341-16.382l6.174-1.374z"
              />
              <g>
                <path
                  fill="#455A64"
                  d="M234.412 445.411c-1.508.871-3.953.871-5.461 0-1.508-.871-1.508-2.282 0-3.153s3.953-.871 5.461 0c1.508.871 1.508 2.283 0 3.153z"
                />
                <path
                  fill="#37474F"
                  d="M227.827 350.79H235.551V443.74800000000005H227.827z"
                />
                <ellipse
                  cx="143.867"
                  cy="392.27"
                  fill="#455A64"
                  rx="3.862"
                  ry="2.23"
                />
                <path
                  fill="#263238"
                  d="M140.013 299.226H147.737V392.18399999999997H140.013z"
                />
                <path
                  fill="#455A64"
                  d="M378.364 362.009c-1.508.871-3.953.871-5.461 0-1.508-.871-1.508-2.282 0-3.153s3.953-.871 5.461 0c1.508.871 1.508 2.282 0 3.153z"
                />
                <path
                  fill="#37474F"
                  d="M371.779 267.388H379.503V360.346H371.779z"
                />
                <g fill="#455A64">
                  <path d="M283.962 291.664c-1.353.781-3.546.781-4.899 0-1.353-.781-1.353-2.047 0-2.828 1.353-.781 3.546-.781 4.899 0 1.352.78 1.352 2.047 0 2.828z" />
                  <path d="M278.055 212.596H284.983V290.172H278.055z" />
                </g>
                <g>
                  <path
                    fill="#263238"
                    d="M140.005 283.827L140.005 302.321 231.695 355.258 231.695 336.763z"
                  />
                  <path
                    fill="#37474F"
                    d="M379.503 251.427L231.695 336.763 231.695 355.258 379.503 269.921z"
                  />
                  <path
                    fill="#455A64"
                    d="M287.813 198.49L140.005 283.827 231.695 336.763 379.503 251.427z"
                  />
                </g>
              </g>
              <path
                fill="#EBEBEB"
                d="M213.659 256.076L247.279 275.486 303.174 243.162 269.559 223.356z"
              />
              <path
                fill="#E0E0E0"
                d="M243.661 250.553L256.274 243.271 248.368 238.707 235.756 245.989z"
              />
              <path
                fill="#E0E0E0"
                d="M248.708 270.638L231.717 260.638 264.922 240.541z"
              />
              <g fill="#FFA8A7">
                <path d="M258.218 208.281l13.45 6.308c5.39 1.264 11.877 3.67 11.877 3.67s9.357 3.825 9.784 6.334c.427 2.509-7.022 8.554-13.567 5.613-1.32-.593-3.702-1.791-5.458-1.977-1.757-.187-6.973-1.008-10.749-4.609l-15.697-4.083c-.001-.001-.783-9.695 10.36-11.256z" />
                <path d="M266.926 227.044c1.558 1.667 5.999 5.877 6.968 7.093.969 1.216 3.258-1.911-.755-6.571 0 0-5.343-1.847-9.69-5.275 0-.001 1.919 3.086 3.477 4.753z" />
              </g>
              <g>
                <path
                  fill="#FFA8A7"
                  d="M212.662 146.809H228.627V166.129H212.662z"
                />
                <path
                  fill="#F28F8F"
                  d="M228.626 166.129c-5.642-2.178-11.538-6.549-14.666-13.948v-5.372h14.666v19.32z"
                />
                <path
                  fill="#FFA8A7"
                  d="M233.998 121.303s14.521 1.747 11.191 26.553c-1.54 11.472-4.605 17.272-13.45 16.29-10.023-1.112-23.868-8.896-21.722-28.552 2.146-19.656 23.981-14.291 23.981-14.291z"
                />
                <path
                  fill="#F28F8F"
                  d="M234.812 143.423L234.286 151.988 239.397 150.756z"
                />
                <g fill="#263238">
                  <path d="M227.209 142.649a1.748 1.748 0 103.49.215 1.748 1.748 0 00-3.49-.215zM238.763 142.137a1.748 1.748 0 103.49.215 1.748 1.748 0 00-3.49-.215zM242.857 138.74l-3.288-2.236s1.394-1.281 2.647-.383c1.254.898.641 2.619.641 2.619zM228.422 138.349l-3.553 1.785s-.441-1.84.953-2.499c1.394-.658 2.6.714 2.6.714z" />
                </g>
                <path
                  fill="#F28F8F"
                  d="M234.537 155.469s-3.33.099-5.526-1.849c0 0-.565 2.935 1.879 3.653 2.444.719 3.647-1.804 3.647-1.804z"
                />
                <path
                  fill="#263238"
                  d="M212.488 143.223s2.235 4.643 3.61 4.482 0-17.801 2.864-17.915c2.864-.115 16.357 6.591 28.293-2.062 4.582-3.322 5.498-11.798 2.749-10.996-2.749.802-6.46 3.207-11.477 2.864-5.018-.344-22.543-8.476-26.896 2.978 0 0-9.706-.791-6.06 18.471.905 4.782 3.769 16.649 7.091 17.817l-.174-15.639z"
                />
                <path
                  fill="#FFA8A7"
                  d="M213.275 147.459c.04-1.451-.193-2.911-.787-4.236-.666-1.485-1.843-2.985-3.885-3.041-4.484-.123-5.089 4.194-5.029 5.731.159 4.036 3.426 8.396 9.508 8.563l.193-7.017z"
                />
              </g>
              <path
                fill="#FFA8A7"
                d="M214.663 233.909l11.437 9.061s3.618.349 5.804 1.005c2.186.656 7.929 2.768 9.449 3.096 1.519.329-.445 2.945-4.418 1.994 0 0 8.338 5.714 8.226 8.257-.112 2.543-8.67 6.879-14.446 2.621-1.165-.859-3.24-2.532-4.918-3.085-1.678-.553-6.603-2.458-9.534-6.775l-10.001-5.214c-.001 0-2.82-11.787 8.401-10.96z"
              />
              <g>
                <path
                  fill="#FFA8A7"
                  d="M202.177 171.207s6.677 5.175 2.575 21.242c-4.103 16.067-6.294 29.921-6.294 29.921l16.205 11.538s-6.851 2.435-8.402 10.96c0 0-25.543-10.042-26.058-16.486-.515-6.444 5.327-34.354 6.216-39.484.888-5.13 5.428-15.262 15.758-17.691z"
                />
                <path
                  fill="#F28F8F"
                  d="M198.458 222.371s-3.286-.701-6.11.058c0 0 2.504-1.547 6.248-1.55l-.138 1.492z"
                />
              </g>
              <path
                fill="#FAFAFA"
                d="M310.967 206.126l-5.845 38.257a.087.087 0 01-.043.063l-58.056 33.673a.088.088 0 01-.132-.09l5.669-37.098a5.504 5.504 0 012.563-3.86l53.26-32.661c1.24-.762 2.804.276 2.584 1.716z"
              />
              <path
                fill="#E0E0E0"
                d="M247.023 278.118l-31.013-17.963a4.717 4.717 0 01-2.352-4.08l33.621 19.41-.256 2.633zM277.367 242.994c0 2.732 1.918 3.84 4.285 2.474 2.366-1.366 4.285-4.689 4.285-7.422 0-2.732-1.918-3.84-4.285-2.474-2.367 1.367-4.285 4.69-4.285 7.422z"
              />
              <path
                fill="#263238"
                d="M213.169 128.208s-2.634-3.895-1.031-5.155c1.604-1.26 2.864 2.749 1.031 5.155z"
              />
              <path
                fill="#263238"
                d="M213.614 129.021s-4.666-.581-4.559-2.617c.107-2.037 3.954-.346 4.559 2.617z"
              />
              <path
                fill="#FFA8A7"
                d="M212.662 166.129s3.425 9.024 11.328 7.878c7.904-1.146 4.636-7.878 4.636-7.878h-15.964z"
              />
              <path
                fill="#BA68C8"
                d="M202.177 171.207s5.203 2.49 4.402 12.954c-.802 10.464-4.925 31.541-4.925 31.541s-18.618 7.533-20.389-3.093c-.458-2.749 4.238-28.178 8.247-33.562 4.009-5.383 8.539-7.102 12.665-7.84z"
              />
              <path
                d="M202.177 171.207s5.203 2.49 4.402 12.954c-.802 10.464-4.925 31.541-4.925 31.541s-18.618 7.533-20.389-3.093c-.458-2.749 4.238-28.178 8.247-33.562 4.009-5.383 8.539-7.102 12.665-7.84z"
                opacity="0.2"
              />
              <g>
                <path
                  fill="#455A64"
                  d="M257.633 353.976s1.159 1.826 3.041 2.123c1.125.178-1.157-2.752 1.567-3.926 2.724-1.174 8.952-2.795 9.506-.451l.69 2.92a17.357 17.357 0 003.841 7.45c1.869 2.131 4.289 4.672 6.165 5.884 3.556 2.297 9.405 7.845 1.897 12.569-7.507 4.724-16.736.738-18.542-4.638-1.807-5.375-3.718-6.929-4.681-7.821-.963-.892-3.212-2.294-4.058-5.92-.549-2.353-.863-5.37-1.015-7.196a2.681 2.681 0 011.236-2.488l.353 1.494z"
                />
                <path
                  fill="#263238"
                  d="M284.342 380.546c-7.507 4.725-16.736.738-18.542-4.637-1.807-5.375-3.718-6.929-4.681-7.821-.863-.799-2.75-2.022-3.744-4.872.013.148.03.3.039.445.287 4.653 3.138 5.743 4.101 6.635.963.892 2.54 2.366 4.346 7.741 1.807 5.375 11.327 8.726 18.834 4.002 3.644-2.293 4.137-4.779 3.278-6.994.138 1.804-.787 3.712-3.631 5.501z"
                />
              </g>
              <g>
                <path
                  fill="#BA68C8"
                  d="M248.259 309.164l-23.923 13.812-30.194-17.432 23.972-13.84a2.05 2.05 0 012.052 0l28.093 16.22a.716.716 0 010 1.24z"
                />
                <path
                  d="M248.259 309.164l-23.923 13.812-30.194-17.432 23.972-13.84a2.05 2.05 0 012.052 0l28.093 16.22a.716.716 0 010 1.24z"
                  opacity="0.7"
                />
                <g fill="#FFF">
                  <path d="M246.602 308.657l-22.267 12.856-28.103-16.225 22.312-12.882a1.91 1.91 0 011.91 0l26.147 15.096a.667.667 0 01.001 1.155z" />
                  <path d="M224.335 321.512L224.335 319.005 246.935 305.957 246.935 308.093z" />
                </g>
                <path
                  fill="#E0E0E0"
                  d="M224.335 321.512L224.335 319.005 196.233 302.78 196.233 305.287z"
                />
                <path
                  fill="#BA68C8"
                  d="M248.259 305.193l-23.923 13.812-30.194-17.432 23.972-13.84a2.055 2.055 0 012.052 0l28.093 16.22a.716.716 0 010 1.24z"
                />
                <path
                  d="M248.259 305.193l-23.923 13.812-30.194-17.432 23.972-13.84a2.055 2.055 0 012.052 0l28.093 16.22a.716.716 0 010 1.24z"
                  opacity="0.5"
                />
                <g fill="#FFF">
                  <path d="M221.215 321.174a.532.532 0 01-.449-.025.534.534 0 01-.286-.478v-2.268c0-1.041.557-2.018 1.452-2.548l.085-.051a.264.264 0 01.269-.002.262.262 0 01.135.233.47.47 0 00.94 0c0-.439-.228-.832-.61-1.049a1.194 1.194 0 00-1.214.01l-.085.05a3.917 3.917 0 00-1.914 3.357v2.268a1.48 1.48 0 001.482 1.482c.288 0 .575-.084.824-.25a.458.458 0 00.183-.259l-.812-.47zM216.745 318.594a.532.532 0 01-.449-.025.534.534 0 01-.286-.477v-2.268c0-1.041.557-2.017 1.452-2.548l.085-.05a.264.264 0 01.269-.002.262.262 0 01.135.233.47.47 0 00.94 0c0-.439-.228-.832-.61-1.049a1.194 1.194 0 00-1.214.01l-.085.051a3.917 3.917 0 00-1.914 3.357v2.268a1.48 1.48 0 002.306 1.232.458.458 0 00.183-.259l-.812-.473zM212.275 316.014a.532.532 0 01-.449-.025.534.534 0 01-.286-.477v-2.268c0-1.041.557-2.017 1.452-2.548l.085-.051a.264.264 0 01.269-.002.262.262 0 01.135.233.47.47 0 10.94 0c0-.44-.228-.832-.61-1.049a1.193 1.193 0 00-1.213.01l-.085.051a3.917 3.917 0 00-1.914 3.357v2.268a1.48 1.48 0 002.306 1.232.458.458 0 00.183-.259l-.813-.472zM207.805 313.434a.532.532 0 01-.449-.025.534.534 0 01-.286-.477v-2.268c0-1.041.557-2.018 1.453-2.548l.085-.051a.264.264 0 01.269-.002.262.262 0 01.135.233.47.47 0 10.94 0c0-.44-.228-.832-.61-1.049a1.197 1.197 0 00-1.214.01l-.085.051a3.918 3.918 0 00-1.914 3.357v2.268a1.48 1.48 0 001.482 1.482c.288 0 .575-.084.824-.25a.46.46 0 00.183-.259l-.813-.472zM203.335 310.854a.529.529 0 01-.449-.026.534.534 0 01-.286-.478v-2.268c0-1.041.557-2.018 1.453-2.548l.085-.05a.262.262 0 01.269-.002.262.262 0 01.135.233.47.47 0 00.94 0c0-.44-.228-.832-.61-1.05a1.194 1.194 0 00-1.214.01l-.086.051a3.918 3.918 0 00-1.914 3.357v2.268a1.48 1.48 0 001.482 1.482c.288 0 .575-.084.824-.25a.464.464 0 00.183-.259l-.812-.47zM198.865 308.274a.529.529 0 01-.449-.026.534.534 0 01-.286-.477v-2.268c0-1.041.557-2.018 1.452-2.548l.085-.051a.262.262 0 01.269-.002.262.262 0 01.135.233.47.47 0 00.94 0c0-.44-.228-.832-.61-1.05a1.194 1.194 0 00-1.214.01l-.085.05a3.917 3.917 0 00-1.914 3.357v2.268a1.48 1.48 0 001.482 1.482c.288 0 .575-.084.824-.25a.464.464 0 00.183-.259l-.812-.469z" />
                </g>
                <path
                  fill="#E6E6E6"
                  d="M251.345 298.95L225.481 313.883 191.823 294.451 217.687 279.518z"
                />
                <g>
                  <path
                    fill="#FAFAFA"
                    d="M252.831 298.462L225.807 311.176 193.894 288.993 220.918 276.279z"
                  />
                </g>
              </g>
              <g>
                <path
                  fill="#BA68C8"
                  d="M192.501 258.75h-21.948l1.969 23.233h.008c.116 1.237.982 2.456 2.619 3.401 3.523 2.034 9.235 2.034 12.758 0 1.637-.945 2.503-2.163 2.619-3.401h.006l1.969-23.233z"
                />
                <path
                  fill="#E0E0E0"
                  d="M193.905 257.481v-1.841h-.433c-.544-1.171-1.6-2.279-3.191-3.198-4.834-2.791-12.671-2.791-17.505 0-1.591.919-2.648 2.027-3.191 3.198h-.434v1.855c0 1.829 1.208 3.658 3.625 5.053 4.834 2.791 12.671 2.791 17.505 0 2.423-1.398 3.63-3.233 3.624-5.067z"
                />
                <path
                  fill="#EBEBEB"
                  d="M190.281 260.802c-4.834 2.791-12.671 2.791-17.505 0s-4.834-7.315 0-10.106c4.834-2.791 12.671-2.791 17.505 0 4.833 2.79 4.834 7.315 0 10.106z"
                />
                <path
                  fill="#E0E0E0"
                  d="M191.445 254.983v-1.475h-.347c-.436-.938-1.282-1.826-2.557-2.562-3.873-2.236-10.153-2.236-14.026 0-1.275.736-2.121 1.624-2.557 2.562h-.348v1.487c0 1.465.968 2.931 2.905 4.049 3.873 2.236 10.152 2.236 14.025 0 1.943-1.122 2.91-2.592 2.905-4.061z"
                />
                <path
                  fill="#F5F5F5"
                  d="M188.541 257.643c-3.873 2.236-10.152 2.236-14.025 0-3.873-2.236-3.873-5.862 0-8.098 3.873-2.236 10.152-2.236 14.026 0 3.872 2.237 3.872 5.862-.001 8.098z"
                />
                <path
                  fill="#F0F0F0"
                  d="M186.923 256.463c-2.974 1.72-7.812 1.72-10.797 0-2.885-1.664-2.985-4.328-.3-6.048.1-.067.2-.133.3-.189a9.205 9.205 0 012.086-.854c2.841-.788 6.358-.51 8.711.854 2.985 1.721 2.985 4.517 0 6.237z"
                />
                <path
                  fill="#E0E0E0"
                  d="M176.129 251.116c2.982-1.722 7.816-1.722 10.798 0 1.296.748 2.027 1.698 2.197 2.674.221-1.271-.51-2.586-2.197-3.56-2.982-1.722-7.817-1.722-10.798 0-1.686.973-2.417 2.289-2.197 3.56.17-.976.902-1.926 2.197-2.674z"
                />
                <path
                  fill="#E0E0E0"
                  d="M180.21 251.414l-2.219 1.409-2.164-1.553v-.854c.1-.067.2-.133.3-.189a9.205 9.205 0 012.086-.854v.643l1.997 1.398z"
                />
              </g>
            </g>
            <g>
              <path
                fill="#BA68C8"
                d="M440.865 114.948L316.384 43.079c-1.428-.824-2.713-.763-3.623-.007l-4.309 2.98 2.939 3.633V150.07c0 3.677 2.236 7.949 4.993 9.541l123.243 71.154.229 3.915 4.54-3.112c.904-.683 1.462-2.025 1.462-3.863V124.49c0-3.678-2.235-7.949-4.993-9.542z"
              />
              <path
                d="M440.865 114.948L316.384 43.079c-1.428-.824-2.713-.763-3.623-.007l-4.309 2.98 2.939 3.633V150.07c0 3.677 2.236 7.949 4.993 9.541l123.243 71.154.229 3.915 4.54-3.112c.904-.683 1.462-2.025 1.462-3.863V124.49c0-3.678-2.235-7.949-4.993-9.542z"
                opacity="0.3"
              />
              <path
                fill="#BA68C8"
                d="M436.625 234.399L312.144 162.53c-2.758-1.592-4.994-5.864-4.994-9.541V49.773c0-3.677 2.236-5.367 4.994-3.775l124.481 71.869c2.758 1.592 4.994 5.864 4.994 9.541v103.216c-.001 3.677-2.236 5.367-4.994 3.775z"
              />
              <path
                fill="#BA68C8"
                d="M436.625 234.399L312.144 162.53c-2.758-1.592-4.994-5.864-4.994-9.541V49.773c0-3.677 2.236-5.367 4.994-3.775l124.481 71.869c2.758 1.592 4.994 5.864 4.994 9.541v103.216c-.001 3.677-2.236 5.367-4.994 3.775z"
              />
              <path
                fill="#455A64"
                d="M436.625 117.867L312.144 45.998c-2.758-1.592-4.994.098-4.994 3.775v5.046l134.468 77.635v-5.046c0-3.677-2.235-7.949-4.993-9.541z"
              />
              <path
                fill="#BA68C8"
                d="M310.162 46.398c.443 0 .955.161 1.482.465l124.481 71.869c2.436 1.406 4.493 5.379 4.493 8.675v103.216c0 2.05-.789 3.374-2.011 3.374-.449 0-.948-.157-1.482-.465l-124.481-71.869c-2.436-1.406-4.494-5.379-4.494-8.675V49.773c0-2.05.79-3.375 2.012-3.375m0-1c-1.772 0-3.011 1.636-3.011 4.374v103.216c0 3.677 2.236 7.949 4.994 9.541l124.481 71.869c.704.407 1.375.599 1.982.599 1.772 0 3.011-1.636 3.011-4.374V127.408c0-3.677-2.236-7.949-4.993-9.541L312.144 45.998c-.704-.407-1.375-.6-1.982-.6z"
              />
              <g fill="#FFF">
                <path d="M364.856 100.043c-.18 0-.362-.045-.529-.142l-47.384-27.357a1.059 1.059 0 011.06-1.835l47.384 27.357a1.06 1.06 0 01-.531 1.977zM431.527 138.535c-.18 0-.362-.046-.529-.142l-35.1-20.265a1.059 1.059 0 111.06-1.834l35.1 20.265a1.059 1.059 0 01-.531 1.976zM388.818 113.877c-.18 0-.362-.046-.529-.142l-14.257-8.231a1.06 1.06 0 011.059-1.835l14.257 8.231a1.06 1.06 0 01-.53 1.977zM364.856 166.41c-.18 0-.362-.046-.529-.142l-47.384-27.357a1.059 1.059 0 011.06-1.835l47.384 27.357a1.06 1.06 0 01-.531 1.977zM431.527 204.903c-.18 0-.362-.045-.529-.142l-35.1-20.266a1.06 1.06 0 011.06-1.834l35.1 20.265a1.059 1.059 0 01-.531 1.977zM388.818 180.244c-.18 0-.362-.045-.529-.142l-14.257-8.231a1.06 1.06 0 011.059-1.835l14.257 8.231a1.06 1.06 0 01-.53 1.977zM364.856 182.014c-.18 0-.362-.045-.529-.142l-47.384-27.357a1.06 1.06 0 011.059-1.835l47.384 27.357a1.06 1.06 0 01-.53 1.977zM416.588 211.882c-.18 0-.362-.045-.529-.142l-20.161-11.639a1.059 1.059 0 111.059-1.834l20.161 11.639a1.06 1.06 0 01-.53 1.976zM388.818 195.849c-.18 0-.362-.045-.529-.142l-14.257-8.231a1.06 1.06 0 01-.388-1.447 1.06 1.06 0 011.447-.388l14.257 8.231a1.06 1.06 0 01-.53 1.977zM341.226 94.646c-.18 0-.362-.045-.529-.142L316.943 80.79a1.059 1.059 0 111.06-1.834l23.753 13.714a1.06 1.06 0 01-.53 1.976zM409.661 134.157c-.18 0-.362-.045-.529-.142l-35.1-20.265a1.06 1.06 0 011.059-1.835l35.1 20.265a1.06 1.06 0 01-.53 1.977zM365.187 108.48c-.18 0-.362-.045-.529-.142l-14.256-8.231a1.058 1.058 0 111.059-1.834l14.256 8.231a1.059 1.059 0 01-.53 1.976zM364.856 116.536c-.18 0-.362-.045-.529-.142l-47.384-27.357a1.06 1.06 0 011.059-1.835l47.384 27.357a1.06 1.06 0 01-.53 1.977zM405.777 140.162c-.18 0-.362-.045-.529-.142l-9.35-5.398a1.06 1.06 0 011.06-1.835l9.35 5.398a1.059 1.059 0 01-.531 1.977zM345.901 113.838c-.18 0-.362-.045-.529-.142l-9.35-5.398a1.06 1.06 0 011.059-1.835l9.35 5.398a1.06 1.06 0 01-.53 1.977zM388.818 130.37c-.18 0-.362-.045-.529-.142l-14.257-8.231a1.06 1.06 0 011.059-1.835l14.257 8.231a1.06 1.06 0 01-.53 1.977zM332.66 106.193c-.18 0-.362-.045-.529-.142l-15.188-8.768a1.06 1.06 0 011.059-1.835l15.188 8.768a1.06 1.06 0 01-.53 1.977zM365.187 124.974c-.18 0-.362-.045-.529-.142l-14.256-8.231a1.058 1.058 0 111.059-1.834l14.256 8.231a1.059 1.059 0 01-.53 1.976zM364.856 133.63c-.18 0-.362-.045-.529-.142l-47.384-27.357a1.06 1.06 0 011.059-1.835l47.384 27.357a1.06 1.06 0 01-.53 1.977zM431.527 172.123c-.18 0-.362-.045-.529-.142l-35.1-20.265a1.059 1.059 0 111.06-1.834l35.1 20.265a1.059 1.059 0 01-.531 1.976zM388.818 147.465c-.18 0-.362-.045-.529-.142l-14.257-8.231a1.06 1.06 0 011.059-1.835l14.257 8.231a1.06 1.06 0 01-.53 1.977zM341.226 128.234c-.18 0-.362-.045-.529-.142l-23.753-13.714a1.06 1.06 0 011.059-1.835l23.753 13.714a1.06 1.06 0 01-.53 1.977zM409.661 167.745c-.18 0-.362-.045-.529-.142l-35.1-20.265a1.06 1.06 0 011.059-1.835l35.1 20.265a1.06 1.06 0 01-.53 1.977zM365.187 142.068c-.18 0-.362-.045-.529-.142l-14.256-8.231a1.06 1.06 0 011.059-1.835l14.256 8.231a1.059 1.059 0 01-.53 1.977zM364.856 150.124c-.18 0-.362-.045-.529-.142l-47.384-27.357a1.06 1.06 0 011.059-1.835l47.384 27.357a1.06 1.06 0 01-.53 1.977zM405.777 173.749c-.18 0-.362-.045-.529-.142l-9.35-5.398a1.06 1.06 0 011.06-1.835l9.35 5.398a1.059 1.059 0 01-.531 1.977zM345.901 147.426c-.18 0-.362-.045-.529-.142l-9.35-5.398a1.059 1.059 0 111.06-1.834l9.35 5.398a1.06 1.06 0 01-.531 1.976zM388.818 163.958c-.18 0-.362-.045-.529-.142l-14.257-8.231a1.06 1.06 0 01-.388-1.447 1.062 1.062 0 011.447-.388l14.257 8.231a1.06 1.06 0 01-.53 1.977zM332.66 139.781c-.18 0-.362-.046-.529-.142l-15.188-8.768a1.06 1.06 0 011.059-1.835l15.188 8.768a1.06 1.06 0 01-.53 1.977zM365.187 158.561c-.18 0-.362-.045-.529-.142l-14.256-8.231a1.06 1.06 0 011.059-1.835l14.256 8.232a1.059 1.059 0 01-.53 1.976zM345.901 163.233c-.18 0-.362-.045-.529-.142l-9.35-5.398a1.06 1.06 0 011.059-1.835l9.35 5.398a1.06 1.06 0 01-.53 1.977zM332.66 155.589c-.18 0-.362-.045-.529-.142l-15.188-8.768a1.058 1.058 0 111.059-1.834l15.188 8.768a1.06 1.06 0 01-.53 1.976zM365.187 174.369c-.18 0-.362-.046-.529-.142l-14.256-8.231a1.06 1.06 0 011.059-1.835l14.256 8.231a1.059 1.059 0 01-.53 1.977z" />
              </g>
              <g>
                <path
                  fill="#263238"
                  d="M326.853 82.828v38.344c0 .615-.226 1.029-.572 1.164l-.01.003-.002.002-1.468.804.008-1.307-.208-39.422 1.922-.971c.206.441.33.929.33 1.383z"
                />
                <path
                  fill="#37474F"
                  d="M326.524 81.447l-1.922.971-46.492-27.254-1.108-.645 1.531-.862.044-.026v-.001c.244-.147.564-.137.916.066l45.977 26.491c.422.244.8.714 1.054 1.26z"
                />
                <path
                  fill="#455A64"
                  d="M325.186 83.664v38.09c0 .53-.169.91-.438 1.088l-.088.048c-.234.111-.528.087-.848-.098L278.111 96.46c-.759-.438-1.376-1.615-1.376-2.626V55.745c0-.512.157-.883.411-1.069a.623.623 0 01.14-.079c.23-.098.515-.069.825.109l45.701 26.333c.404.233.767.676 1.018 1.191.221.451.356.96.356 1.434z"
                />
                <text
                  fill="#FAFAFA"
                  fontFamily="Montserrat-Bold"
                  fontSize="25.8"
                  transform="matrix(-.866 -.5 0 1 316.95 108.348)"
                >
                        &lt;/&gt;
                </text>
                <path
                  fill="#37474F"
                  d="M277.382 54.64c.128 0 .27.044.422.132l45.977 26.491c.346.199.682.596.922 1.09.214.436.333.909.333 1.33v38.32c0 .424-.119.745-.308.871l-.076.042a.461.461 0 01-.197.042.855.855 0 01-.419-.131l-45.977-26.491c-.681-.393-1.257-1.502-1.257-2.421v-38.32c0-.409.113-.726.31-.871a.467.467 0 01.27-.084m0-.255a.708.708 0 00-.422.135c-.255.187-.413.56-.413 1.076v38.318c0 1.018.62 2.201 1.384 2.642l45.977 26.491c.194.112.379.166.547.166a.71.71 0 00.306-.067l.089-.049c.271-.179.441-.562.441-1.095v-38.32c0-.477-.136-.988-.359-1.442-.252-.518-.617-.964-1.024-1.198L277.931 54.55a1.116 1.116 0 00-.549-.165z"
                />
              </g>
              <g fill="#FFF">
                <path d="M319.457 55.627c0 1.091-.766 1.533-1.711.988-.945-.546-1.711-1.872-1.711-2.963s.766-1.533 1.711-.988c.945.546 1.711 1.872 1.711 2.963zM325.815 59.553c0 1.091-.766 1.533-1.711.988-.945-.545-1.711-1.872-1.711-2.963s.766-1.533 1.711-.988c.946.546 1.711 1.872 1.711 2.963zM332.174 63.479c0 1.091-.766 1.533-1.711.988-.945-.545-1.711-1.872-1.711-2.963s.766-1.533 1.711-.988c.945.545 1.711 1.872 1.711 2.963z" />
              </g>
            </g>
          </svg>
        </div>
        <div className="p-8 font-mono flex flex-col justify-center">
          <div className="flex flex-col items-center text-center">
            <h1 className="text-indigo-600 text-4xl animate-fade-up flex flex-row">Institute Technical Council</h1>
            <h3 className="text-indigo-600 text-3xl animate-fade-up flex flex-row">Presents</h3>
            <h1 className="text-indigo-600 text-4xl animate-fade-up flex flex-row">Summer of Tech</h1>
          </div>
          <div className="mt-10 flex flex-col items-center dark:text-white ">
            <h1 className="animate-fade-up text-justify utilities">Summer of Tech (ITSA) 2026-27 is the Institute Technical Council’s flagship summer initiative, a gateway for students to truly explore the spirit of technology at IIT Bombay. It brings together a vibrant ecosystem of student driven programs that transform curiosity into creation, combining thoughtful mentorship with the freedom to innovate. 
Through initiatives such as ITSP, SOC, SoS, SOQ, KSP, and SOR, Summer of Tech spans a wide spectrum of learning, from building real world products and writing code to exploring science, robotics, astronomy, and quantitative finance. Students do not just study concepts, they bring ideas to life through projects, collaboration, and continuous discovery.
At its core, Summer of Tech celebrates the joy of learning by doing. It offers flexibility, depth, and a strong community that encourages experimentation and growth. Whether you are beginning your journey or refining your skills, it provides the perfect platform to turn ambition into meaningful impact.</h1>
            {!authToken ? (
              <button
                className="animate-fade-up inline-flex items-center gap-2 rounded border border-indigo-600 bg-indigo-600 px-8 py-3 text-white hover:bg-transparent hover:text-indigo-600 focus:outline-none focus:ring active:text-indigo-500 mt-10"
                onClick={handleLogin}
              >
                <span className="text-sm font-medium ">Explore</span>

                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 pl-1">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15.59 14.37a6 6 0 0 1-5.84 7.38v-4.8m5.84-2.58a14.98 14.98 0 0 0 6.16-12.12A14.98 14.98 0 0 0 9.631 8.41m5.96 5.96a14.926 14.926 0 0 1-5.841 2.58m-.119-8.54a6 6 0 0 0-7.381 5.84h4.8m2.581-5.84a14.927 14.927 0 0 0-2.58 5.84m2.699 2.7c-.103.021-.207.041-.311.06a15.09 15.09 0 0 1-2.448-2.448 14.9 14.9 0 0 1 .06-.312m-2.24 2.39a4.493 4.493 0 0 0-1.757 4.306 4.493 4.493 0 0 0 4.306-1.758M16.5 9a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z" />
                </svg>

              </button>
            ) : (
              <div className="animate-fade-up mt-10 flex flex-col items-center gap-4">
                {isManager && (
                  <button className="sot-btn-manager" onClick={() => navigate('/manager')}>
                    Manager Dashboard
                  </button>
                )}
                {memberships.length > 0 && (
                  <p className="sot-hero-welcome">
                    You're enrolled in {memberships.filter((m) => m.is_approved).length} domain{memberships.length !== 1 ? 's' : ''}
                  </p>
                )}
              </div>
            )}
          </div>
        </div>
      </section>

      {/* My Memberships strip (if logged in) */}
      {authToken && memberships.filter((m) => m.is_approved).length > 0 && (
        <section className="sot-my-section">
          <div className="sot-my-inner">
            <h2 className="sot-my-title">Your Memberships</h2>
            <div className="sot-my-chips">
              {memberships
                .filter((m) => m.is_approved)
                .map((m, i) => (
                  <button
                    key={i}
                    className="sot-my-chip"
                    onClick={() => m.domain && handleDomainClick({ slug: m.domain })}
                  >
                    <span className="sot-my-chip-domain">{m.domain_name || 'Platform'}</span>
                    <span className={roleBadgeClass(m.role)}>{m.role}</span>
                  </button>
                ))}
            </div>
          </div>
        </section>
      )}

      {/* Domains Grid */}
      <section className="sot-domains-section">
        <div className="sot-domains-inner">
          <div className="sot-section-header">
            <h2 className="sot-section-title">Explore Domains</h2>
            <p className="sot-section-sub">
              Each domain runs independently with its own mentors, mentees, and projects.
            </p>
          </div>

          {!Array.isArray(domains) || domains.length === 0 ? (
            <div className="sot-empty">
              <p>No domains published yet. Check back soon!</p>
            </div>
          ) : (
            <div className="sot-grid">
              {domains.map((domain) => {
                const myRoles = getMyRoles(domain.slug);
                return (
                  <DomainCard
                    key={domain.slug}
                    domain={domain}
                    myRoles={myRoles}
                    authToken={authToken}
                    onClick={() => handleDomainClick(domain)}
                  />
                );
              })}
            </div>
          )}
        </div>
      </section>

      {/* Footer */}
      <footer className="sot-footer">
        <p>© {new Date().getFullYear()} ITC, IIT Bombay · Summer of Tech</p>
      </footer>

      {/* Role Selection Modal */}
      {roleModal && (
        <div className="sot-modal-overlay" onClick={() => setRoleModal(null)}>
          <div className="sot-modal" onClick={(e) => e.stopPropagation()}>
            <h3 className="sot-modal-title">{roleModal.domain.name}</h3>
            <p className="sot-modal-desc">
              Choose how you want to participate in this domain:
            </p>
            <div className="sot-modal-actions">
              {roleModal.options.map((option, idx) => (
                <button
                  key={idx}
                  className={`sot-modal-btn ${
                    option.role === 'mentor' ? 'sot-modal-btn-mentor' : 'sot-modal-btn-mentee'
                  }`}
                  onClick={() => handleModalAction(roleModal.domain, option.role, option.action)}
                >
                  {option.role === 'mentor' ? '🎓' : '👤'} {option.label}
                  {option.action === 'apply' && (
                    <span style={{ fontSize: '0.75rem', display: 'block', marginTop: '4px', opacity: 0.8 }}>
                      {option.role === 'mentor' ? 'Requires approval' : 'Browse & apply to projects'}
                    </span>
                  )}
                </button>
              ))}
            </div>
            <button className="sot-modal-close" onClick={() => setRoleModal(null)}>
              Cancel
            </button>
          </div>
        </div>
      )}
    </>
  );
}

function DomainCard({ domain, myRoles, authToken, onClick }) {
  const [hovered, setHovered] = useState(false);

  const slugColors = {
    soc: { from: '#6366f1', to: '#8b5cf6' },
    soq: { from: '#06b6d4', to: '#0ea5e9' },
    sor: { from: '#f59e0b', to: '#ef4444' },
  };
  const colors = slugColors[domain.slug] || { from: '#10b981', to: '#059669' };

  return (
    <div
      className={`sot-card ${hovered ? 'sot-card-hovered' : ''}`}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && onClick()}
      aria-label={`Open ${domain.name}`}
    >
      {/* Cover */}
      <div
        className="sot-card-cover"
        style={{
          background: domain.cover_photo_url
            ? `url(${domain.cover_photo_url}) center/cover`
            : `linear-gradient(135deg, ${colors.from}, ${colors.to})`,
        }}
      >
        <div className="sot-card-cover-overlay" />
        <div className="sot-card-slug">{domain.slug.toUpperCase()}</div>

        {/* My role badges in this domain */}
        {myRoles.length > 0 && (
          <div className="sot-card-role-badges">
            {myRoles.filter(role => {
              // Hide mentor badge if mentor portal access is disabled
              if (role === 'mentor' && domain.mentor_portal_access === false) {
                return false;
              }
              return true;
            }).map((role) => (
              <span key={role} className={`sot-card-role-badge sot-card-role-${role}`}>
                {role}
              </span>
            ))}
          </div>
        )}
      </div>

      {/* Body */}
      <div className="sot-card-body">
        <h3 className="sot-card-name">{domain.name}</h3>
        <p className="sot-card-desc">
          {domain.description
            ? domain.description.length > 120
              ? domain.description.slice(0, 120) + '…'
              : domain.description
            : 'A new domain under Summer of Tech.'}
        </p>

        <div className="sot-card-footer">
         {/* <span className="sot-card-count">
            {domain.member_count} member{domain.member_count !== 1 ? 's' : ''}
          </span> */}
          
          {/* Registration status badges */}
          <div className="sot-card-reg-status">
            {domain.mentee_reg_open && (
              <span className="sot-reg-badge sot-reg-open">Mentee: Open</span>
            )}
            {domain.mentor_reg_open && (
              <span className="sot-reg-badge sot-reg-open">Mentor: Open</span>
            )}
          </div>

          {!authToken ? (
            <span className="sot-card-cta">Login to explore →</span>
          ) : (
            <span className="sot-card-cta sot-card-cta-enrolled">Explore →</span>
          )}
        </div>
      </div>
    </div>
 );
} 
